(function ( $ ){

	var defaults = {
		duration: 400
	}

	$.fn.srzsdDrawer = function(options){

		var options = options || {};

		return this.each(function(){

			var kontext = $(this);


				/* Einstellungen über Methode */

			if (typeof options.transition !== "undefined" && typeof defaults.transitions[options.transition] !== "undefined"){
				options.transition = defaults.transitions[options.transition];
			} else {
				delete options.transition;
			}


				/* Einstellungen über Data-Attribute */

			var data = {
				duration: kontext.data("duration"),
				transition: kontext.data("transition")
			}

			if (typeof data.transition !== "undefined" && typeof defaults.transitions[data.transition] !== "undefined"){
				data.transition = defaults.transitions[data.transition];
			} else {
				delete data.transition;
			}


				/* Einstellungen vereinen */


			var settings = $.extend({}, defaults, options, data);

			new Drawer(kontext, settings);

		});

	};


	var Drawer = function(kontext, settings){

		var self = this;

		if ($("li", kontext).length === 0){
			return false;
		}

		this.kontext = kontext;
		this.settings = settings;
		this.counter = 0;

		var container = $("> ul, > ol", this.kontext).eq(0);


			/* Trigger aktivieren */

		$("> li", container).each(function(index){

			var details = $(this).find(".srzsd-drawer-details");

			if (details.length !== 0){

				details.css({
					opacity: 0,
					height: 0,
					overflow: "hidden"
				}).removeClass("js-hidden");

				if ($(this).hasClass("srzsd-drawer-trigger")){
					var trigger = $(this);
				} else {
					var trigger = $(this).find(".srzsd-drawer-trigger");
				}

				details.find("a").click(function(event){
					event.stopPropagation();
				});

				trigger.addClass("srzsd-drawer-expandable").css({
					cursor: "pointer"
				}).click(function(){
					self.wechsel(details);
				});

			}

		});


			/* Drawer einblenden */

		this.kontext.removeClass("js-hidden");

	};


	Drawer.prototype.wechsel = function(details){

		details.stop();

		if (details.height() === 0){

			var hoehe = details.css("height", "auto").height();

			var dauer = this.settings.duration;

			details.closest(".srzsd-drawer-expandable").addClass("srzsd-drawer-open");

			details.css(
				{
					height: 0,
					opacity: 0
				}
			).animate(
				{
					height: hoehe,
					opacity: 1
				},
				dauer,
				function (){
					details.css("height", "auto");
					$(document).trigger("resize");
				}
			);

		} else {

			var dauer = this.settings.duration;

			details.closest(".srzsd-drawer-expandable").removeClass("srzsd-drawer-open");

			details.animate(
				{
					height: 0,
					opacity: 0
				},
				dauer,
				function(){
					$(document).trigger("resize");
					var timer = setTimeout(function(){
						$(window).trigger("scroll");
					}, 250);
				}
			);

		}

	};

}( jQuery ));